module.exports = __webpack_public_path__ + "static/media/beach2384.b986d533.jpg";